import React from 'react'
import { ContrastApiDocs } from './contrast-api-docs'
import { BrowserRouter } from 'react-router-dom'
import { createRoot } from 'react-dom/client'

const container = document.querySelector('main')
const root = createRoot(container as HTMLElement)
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ContrastApiDocs />
    </BrowserRouter>
  </React.StrictMode>
)
